import { render, staticRenderFns } from "./OptionGroupForm.vue?vue&type=template&id=3d8a9c1e&"
import script from "./OptionGroupForm.vue?vue&type=script&lang=ts&"
export * from "./OptionGroupForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports